import React, { useEffect, useState } from "react";
import { getMemoryPreferences, updateMemoryPreferences } from "@/lib/apiClient";

export function MemoryAutomation({memoryUseEnabled=true}) {
  const [enabled, setEnabled] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setError("");
    getMemoryPreferences().then(result => {
      if (active && typeof result.enabled === "boolean") setEnabled(result.enabled);
      else if (active) setError("Muistiasetusta ei voitu ladata.");
    }).catch(() => active && setError("Muistiasetusta ei voitu ladata."));
    return () => { active = false; };
  }, [attempt]);
  const change = async () => {
    if (busy || enabled === null) return;
    setBusy(true);
    setError("");
    try {
      const result = await updateMemoryPreferences(!enabled);
      if (typeof result.enabled !== "boolean") throw new Error("Invalid preference");
      setEnabled(result.enabled);
    } catch {
      setError("Tallennusta ei voitu varmistaa. Lataa asetus uudelleen ennen seuraavaa muutosta.");
    } finally {
      setBusy(false);
    }
  };
  return <div className="mb-4 rounded-xl border border-border p-3">
    <label className="flex min-h-11 cursor-pointer items-center justify-between gap-3 text-sm">
      <span>Automaattinen muistaminen</span>
      <span className="relative inline-flex"><input type="checkbox" role="switch" aria-label="Automaattinen muistaminen" aria-describedby="memory-automation-help"
        checked={enabled === true} disabled={busy || enabled === null || Boolean(error)} onChange={change} className="peer sr-only" />
        <span aria-hidden="true" className="h-7 w-12 rounded-full bg-muted peer-checked:bg-primary peer-disabled:opacity-40 peer-focus-visible:ring-2 peer-focus-visible:ring-primary"><span className={`block h-5 w-5 translate-y-1 rounded-full bg-white transition-transform ${enabled?'translate-x-6':'translate-x-1'}`}/></span></span>
    </label>
    <p id="memory-automation-help" className="text-xs text-muted-foreground" aria-live="polite">{busy ? "Tallennetaan…" : enabled === null ? "Ladataan asetusta…" : enabled ? "Päällä: tärkeät tiedot poimitaan omista viesteistäsi ilman erillistä hyväksyntää." : `Pois: uusia tietoja ei tallenneta automaattisesti. ${memoryUseEnabled?"Aiemmat muistot ovat edelleen käytössä.":"Aiemmat muistot säilyvät, mutta niiden käyttö on pois."} Voit lisätä, muokata ja poistaa niitä itse.`}</p>
    {error && <p role="alert" className="mt-2 text-xs text-destructive">{error}</p>}
    {error && <button type="button" className="min-h-11 text-sm text-primary" onClick={() => {setEnabled(null); setAttempt(value => value + 1);}}>Lataa asetus uudelleen</button>}
  </div>;
}
